module.exports = __webpack_public_path__ + "static/media/phone_5.2a7c93ac.png";